// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1nASi","choiceBoxes":"toolbarselects_choiceBoxes__zNke5","simpleField":"toolbarselects_simpleField__1FvIv"};